
import {configureStore} from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import commonReducer  from "./commonSlice";
import systemReducer from "./systemSlice";

const store = configureStore({
    reducer: {
        auth: authReducer,
        common: commonReducer,
        system: systemReducer

    }
})

export default store;
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
